<template>
  <h3 class="elr-card-subtitle"><slot /></h3>
</template>

<script>
export default {
  name: 'CardDescription'
}
</script>

<style>
.elr-card-subtitle {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0 0 5px;
  font-size: 14px;
  color: #4d4d4d;
}
</style>

